import styled, { css } from 'styled-components';

export const FormCard = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 100%;
    background: ${theme.colors.white};
    box-shadow: 0 2px 30px rgba(0, 0, 0, 0.1);
    padding: 32px 24px 40px;
    border-radius: 8px;
    text-align: center;
  `}
`;

export const FormContainer = styled.div`
  text-align: left;
`;

export const NotFoundContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${theme.spacings.xxl};
    text-align: center;
  `}
`;

export const CheckoutWrapper = styled.div`
  position: relative;
  min-height: 200px;
`;

export const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  transition: opacity 0.3s ease;
`;
